// extracted by mini-css-extract-plugin
export default {"chip":"MGChip_chip__ySJ4u","label":"MGChip_label__gBeb8","iconLeft":"MGChip_iconLeft__N76MH","iconRight":"MGChip_iconRight__-I0x1"};